import { getAllChains, hasCapability } from '~/constants/chains'
import { useActiveOrg } from '~/hooks/org'
import { useAllChainIds } from '~/hooks/utils'

export const useActiveOrgSmartAccountsChainIds = () => {
  const { org: activeOrg } = useActiveOrg()
  const smartAccountsChainIds = activeOrg?.smartAccountsChainIds ?? []
  const transactChainIds = getAllChains()
    .filter((chain) => hasCapability(chain.chainId, 'transact'))
    .map((chain) => chain.chainId)
  const availableChainIds = transactChainIds.filter((id) =>
    smartAccountsChainIds.includes(id),
  )

  return useAllChainIds().filter((chainId) =>
    availableChainIds.includes(chainId),
  )
}
